module.exports = __webpack_public_path__ + "static/wpo-logo-be2426e59524db840faa7f6778b98740.jpg";